import React from 'react';

import { AdminRepsTable } from 'src/components';

import classes from './adminRepImpersonate.module.scss';

export const AdminRepImpersonate = () => {
  return (
    <div className={classes.AdminRepImpersonate}>
      <AdminRepsTable />
    </div>
  );
};
